/**
 * #app_settings.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { GetFieldsRequest, GetFieldsResponse, ValidateFormRequest, ValidateFormResponse } from "./shared.js";
export const AppSettingsServiceName = "devvit.actor.settings.v1alpha.AppSettings";
export class AppSettingsClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || AppSettingsServiceName;
        this.rpc = rpc;
        this.GetAppSettingsFields = this.GetAppSettingsFields.bind(this);
        this.ValidateAppForm = this.ValidateAppForm.bind(this);
    }
    GetAppSettingsFields(request, metadata) {
        const data = GetFieldsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetAppSettingsFields", data, metadata);
        return promise.then((data) => GetFieldsResponse.decode(_m0.Reader.create(data)));
    }
    ValidateAppForm(request, metadata) {
        const data = ValidateFormRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ValidateAppForm", data, metadata);
        return promise.then((data) => ValidateFormResponse.decode(_m0.Reader.create(data)));
    }
}
export const AppSettingsDefinition = {
    name: "AppSettings",
    fullName: "devvit.actor.settings.v1alpha.AppSettings",
    methods: {
        /** Requested by the platform when rendering the configure form upon installing this app */
        getAppSettingsFields: {
            name: "GetAppSettingsFields",
            requestType: GetFieldsRequest,
            requestStream: false,
            responseType: GetFieldsResponse,
            responseStream: false,
            options: {},
        },
        /** Called by the installation form before saving settings to allow for more advanced field validation */
        validateAppForm: {
            name: "ValidateAppForm",
            requestType: ValidateFormRequest,
            requestStream: false,
            responseType: ValidateFormResponse,
            responseStream: false,
            options: {},
        },
    },
};
